<template>
  <div v-if="showSplash" class="splash-screen" :class="{ 'fade-out': fadeOut }">
    <div class="splash-content">
      <div class="logo-container">
        <img src="/src/assets/PrivateAPP.png" alt="Private APP" class="splash-logo" />
      </div>
      <div class="app-title">
        <h1>Private APP</h1>
        <p>AI Knowledge Companion</p>
      </div>
      <div class="loading-indicator">
        <div class="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p>Loading your workspace...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplashScreen',
  data() {
    return {
      showSplash: true,
      fadeOut: false
    }
  },
  mounted() {
    // Show splash for 1.2 seconds, then fade out over 0.5 seconds
    setTimeout(() => {
      this.fadeOut = true;
      setTimeout(() => {
        this.showSplash = false;
        this.$emit('splash-complete');
      }, 500);
    }, 1200);
  }
}
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 25%, #3e5f9f 50%, #4a6ba3 75%, #5577aa 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease-out;
}

.splash-screen.fade-out {
  opacity: 0;
}

.splash-content {
  text-align: center;
  color: white;
}

.logo-container {
  margin-bottom: 40px;
  animation: logoFloat 2s ease-in-out infinite;
}

.splash-logo {
  width: 120px;
  height: auto;
  filter: drop-shadow(0 8px 32px rgba(0, 0, 0, 0.3));
}

.app-title h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 10px 0;
  background: linear-gradient(45deg, #fff, #e3f2fd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.app-title p {
  font-size: 1.2rem;
  font-weight: 300;
  margin: 0 0 60px 0;
  opacity: 0.9;
  letter-spacing: 1px;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.loading-dots {
  display: flex;
  gap: 8px;
}

.loading-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
  animation: dotPulse 1.4s ease-in-out infinite both;
}

.loading-dots span:nth-child(1) { animation-delay: -0.32s; }
.loading-dots span:nth-child(2) { animation-delay: -0.16s; }
.loading-dots span:nth-child(3) { animation-delay: 0; }

.loading-indicator p {
  font-size: 0.9rem;
  opacity: 0.8;
  margin: 0;
  font-weight: 300;
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes dotPulse {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .splash-logo {
    width: 100px;
  }
  
  .app-title h1 {
    font-size: 2rem;
  }
  
  .app-title p {
    font-size: 1rem;
    margin-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .splash-logo {
    width: 80px;
  }
  
  .app-title h1 {
    font-size: 1.8rem;
  }
  
  .app-title p {
    font-size: 0.9rem;
  }
}
</style> 